import memoizeOne from 'memoize-one';

import { LOCALSTORAGE_TOKEN_KEY } from 'app/common/UserContext/utils';

const { PANDAPI_URL } = process.env;
const API_URL = process.env.API_URL ? `${process.env.API_URL}/api` : '';
const SOCKET_URL = process.env.WS_URL ? `${process.env.WS_URL}/socket` : '';
const HASHI_URL = process.env.HASHI_URL ? `${process.env.HASHI_URL}` : '';
const HASHI_WS = process.env.HASHI_WS ? `${process.env.HASHI_WS}/socket` : '';
const CONTROL_URL = process.env.CONTROL_URL ?? '';
const CONTROLE_URL = process.env.CONTROLE_URL ?? '';
const SOL_URL = process.env.SOL_URL ?? '';
const RATCHET_URL = process.env.RATCHET_URL ?? '';
const REGISTRATION_URL = process.env.REGISTRATION_URL ?? '';
const RISK_API_URL = process.env.RISK_API_URL ?? '';
const RISK_WS_URL = process.env.RISK_WS_URL ? `${process.env.RISK_WS_URL}/socket` : '';
const MEILISEARCH_URL = process.env.MEILISEARCH_URL ?? '';

const getHeaders = memoizeOne((token?: string) => ({
  Accept: 'application/json',
  'Content-Type': 'application/json',
  authorization: token || ''
}));

const getControlFrontendUrl = (url: string) => CONTROL_URL + url;
const getControleBackendUrl = (url: string) => CONTROLE_URL + url;

const getPandapiUrl = (url: string) => PANDAPI_URL + url;

const getPandapiWsUrl = (url: string) => (PANDAPI_URL || '').replace('http', 'ws') + url;

const getApiUrl = (url: string) => API_URL + url;

const getWsUrl = () => SOCKET_URL;

const getHashiUrl = (url: string) => HASHI_URL + url;

const getHashiWsUrl = () => HASHI_WS;

const getSolUrl = () => SOL_URL;

const getRegistrationUrl = (url: string) => REGISTRATION_URL + url;

const getToken = () => localStorage.getItem(LOCALSTORAGE_TOKEN_KEY) || '';

const getRatchetUrl = (url: string) => `${RATCHET_URL}${url}?user_path_param=pandascore`;

const getRiskApiUrl = (url: string) => `${RISK_API_URL}${url}`;

const getRiskWsUrl = () => RISK_WS_URL;

const getBetlogMeilisearchUrl = (url: string) => `${MEILISEARCH_URL}${url}`;

const getTangerineHeaders = (headers: { [key: string]: string } = {}) => ({
  Accept: 'application/json',
  'Content-Type': 'application/json',
  authorization: getToken(),
  ...headers
});
const getPandapiHeaders = (headers: { [key: string]: string } = {}) => ({
  Accept: 'application/json',
  'Content-Type': 'application/json',
  authorization: `Bearer ${getToken()}`,
  ...headers
});
const getHashiHeaders = (headers: { [key: string]: string } = {}) => ({
  Accept: 'application/json',
  'Content-Type': 'application/json',
  authorization: getToken(),
  ...headers
});

const getMeilisearchHeaders = (key: string, headers: { [key: string]: string } = {}) => ({
  Accept: 'application/json',
  'Content-Type': 'application/json',
  authorization: `Bearer ${key}`,
  ...headers
});

const getXTotal = (headers: { [key: string]: string } | undefined): number => {
  if (headers && (headers['x-total'] || headers['x-total-count'])) {
    const total = headers['x-total'] || headers['x-total-count'];
    const value = parseInt(total, 10);
    if (!isNaN(value)) {
      return value;
    }
  }
  return 0;
};

const gerTraderAssignationUrl = (type: 'live' | 'microbetting') =>
  type === 'live' ? 'trader' : 'micromarkets_trader';

export {
  getHeaders,
  getPandapiUrl,
  getPandapiWsUrl,
  getApiUrl,
  getControlFrontendUrl,
  getControleBackendUrl,
  getWsUrl,
  getToken,
  getHashiUrl,
  getHashiWsUrl,
  getTangerineHeaders,
  getPandapiHeaders,
  getHashiHeaders,
  getMeilisearchHeaders,
  getXTotal,
  getSolUrl,
  getRatchetUrl,
  gerTraderAssignationUrl,
  getRegistrationUrl,
  getBetlogMeilisearchUrl,
  getRiskApiUrl,
  getRiskWsUrl
};
